<template>
  <div id="app" :class="{ 'navi-open': isOpenNav }">
    <div @click="openMenu" class="overlay-menu"></div>
    <AdminBar v-if="showAdminBar" />
    <div class="navigation-top">
      <NaviButton />
    </div>
    <main
      class="page-content"
      :class="[{ 'fix-transfrom': fixTransfrom }]"
      id="content"
    >
      <router-view :key="key + '-' + currentPageID" />
      <ThemeFooter />
    </main>
    <ThemeNavigation />
    <CookieBar />
  </div>
</template>

<script>
import ThemeNavigation from "@/components/ThemeNavigation";
import NaviButton from "@/components/elements/NaviButton";
const CookieBar = () => import("@/components/elements/CookieBar");
const AdminBar = () => import("@/components/AdminBar");
const ThemeFooter = () => import("@/components/ThemeFooter");

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "App",
  components: {
    AdminBar,
    ThemeFooter,
    ThemeNavigation,
    NaviButton,
    CookieBar
  },
  data() {
    return {
      showAdminBar:
        (WPVUE.user.loggedIn &&
          WPVUE.user.caps === "administrator" &&
          WPVUE.user.admin) ||
        process.env.NODE_ENV === "development"
          ? true
          : false,
      key: window.location.pathname,
      development: process.env.NODE_ENV === "development",
      routerTitle: WPVUE.site_title,
      firstLoad: true,
      pageIsInitialized: false,
      closeMenuViewMQ: null,
      fixTransfrom: false
    };
  },
  computed: {
    ...mapGetters([
      "getStoreVersion",
      "isOpenNav",
      "pageIsLoading",
      "getCurrentPageMeta",
      "userOpenNav"
    ])
  },
  watch: {
    $route(to, from) {
      if (process.env.NODE_ENV === "development") {
        console.log("%c Route To: ", "font-weight: bold; color: #731853");
        console.table([to]);
      }
      this.initLoading();
      //if(to.meta.title) this.routerTitle = to.meta.title;
      //else to.meta.title = WPVUE.site_title,

      //this.getPageByRoute(to);
    },

    pageIsLoading(val) {
      if (!val) {
        //console.log('%c LOADING VALUE: '+val, 'font-weight: bold; color: orange');
        this.$nextTick(() => {
          const preloader = document.getElementById("preloader-page");
          if (preloader)
            document.getElementById("preloader-page").classList.add("loaded");
        });
      }
    },
    // hash scroll
    currentPage(val) {
      if (val) {
        this.$nextTick(() => {
          if (window.location.hash) {
            const hash = location.hash.substring(1);
            const el = document.getElementById(hash);
            if (el)
              $("html, body").animate({ scrollTop: el.offsetTop + 20 }, 450);
          }
        });
      }
    }
  },
  methods: {
    ...mapActions([
      "getPageByRoute",
      "wpGetEverything",
      "loadAppCache",
      "appHearthBeatVersion"
    ]),
    ...mapMutations({
      setPageLoading: "PAGE_IS_LOADING",
      setAppVersion: "UPDATE_APP_VERSION",
      setHeaderStatus: "SET_NAVIGATION_STATUS",
      userActionOpen: "SET_USER_CHANGE_NAVI"
    }),
    openMenu() {
      const action = !this.isOpenNav;
      this.setHeaderStatus(action);
      this.userActionOpen(action);
      $(window).trigger("resize");
    },
    removeNotUpdatingMeta() {
      const toRemove = [
        "meta[name=description]",
        //"meta[name=keywords]",
        "meta[name=author]",
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[property="og:url"]',
        'meta[property="og:site_name"]',
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]'
      ];
      toRemove.forEach(element => {
        let item = document.head.querySelector(element);
        if (item) item.remove();
      });
    },
    redirect404() {
      if (window.location.pathname !== "/404") {
        console.warn("GOING 404");
        this.$router.push("/404");
      }
    },
    cleanLoading() {
      const VM = this;
      VM.getPageByRoute().then(tes => {
        VM.wpGetEverything();
        VM.setPageLoading(false);
        if (tes.status && tes.status === "404") {
          VM.redirect404();
        }
      });
    },
    initLoading() {
      const VM = this;

      if (VM.pageIsInitialized) return false;
      VM.pageIsInitialized = true;

      VM.setPageLoading(true);

      if (
        VM.$route &&
        VM.$route.query &&
        VM.$route.query.preview &&
        VM.$route.query.preview === "1" &&
        VM.$route.query.page_id
      ) {
        console.log("preview");
        VM.cleanLoading();
      } else {
        if (VM.getStoreVersion) {
          VM.loadAppCache().then(e => {
            if (!e) {
              console.log(
                "%c Store NOT LOADED",
                "font-weight: bold; color: red"
              );
              VM.cleanLoading();
            } else {
              console.log("%c Store LOADED", "font-weight: bold; color: green");
              VM.setPageLoading(false);
              const attachmentPage =
                VM.$route.meta && VM.$route.meta.post_type === "attachment";
              if (
                !attachmentPage &&
                !VM.currentPage &&
                window.location.pathname !== "/404"
              ) {
                VM.redirect404();
              }
              if (attachmentPage) {
                VM.getPageByRoute().then(tes => {
                  if (tes.status && tes.status === "404") {
                    VM.redirect404();
                  }
                });
              }
            }

            //check every 5 minutes if content isnt changed while user is browsing page
            setInterval(() => {
              VM.appHearthBeatVersion();
            }, 1000 * 60 * 5);
          });
        } else {
          VM.cleanLoading();
        }
      }
    },
    checkNavigationBehav() {
      const VM = this;
      VM.closeMenuViewMQ = window.matchMedia("screen and (max-width: 1199px)");
      if (VM.closeMenuViewMQ.matches) {
        if (VM.isOpenNav) {
          VM.setHeaderStatus(false);
        }
      }
      VM.closeMenuViewMQ.addListener(function(mq) {
        if (mq.matches) {
          // viewport <= x
          if (VM.isOpenNav) {
            VM.setHeaderStatus(false);
          }
        } else {
          if (!VM.isOpenNav && !VM.userOpenNav) {
            VM.setHeaderStatus(true);
          }
          // viewport > x
        }
      });
    }
  },
  metaInfo() {
    let pageTitle = this.getCurrentPageMeta
      ? this.getCurrentPageMeta.title
      : this.routerTitle;
    //(this.$route && this.$route.name)
    if (this.$route && this.$route.name === "notFound") {
      this.routerTitle = "- " + this.$route.meta.title;
    }
    if (this.routerTitle === pageTitle) {
      this.routerTitle = "";
    }
    if (this.firstLoad && !this.currentPage) {
      this.firstLoad = false;
      this.removeNotUpdatingMeta();
      pageTitle = document.title;
    }
    pageTitle = pageTitle.replace("&ndash;", "—");
    pageTitle = pageTitle.replace("&mdash;", "—");

    return {
      title: pageTitle,
      titleTemplate: this.getCurrentPageMeta
        ? "%s"
        : window.WPVUE.site_name + " " + this.routerTitle,
      link: [
        {
          rel: "canonical",
          href: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.url
            : window.location.href
        }
      ],
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.description
            : window.WPVUE.site_name + " " + this.routerTitle
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.keywords
            : ""
        },
        {
          vmid: "author",
          name: "author",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.author
            : "TankenBak"
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.og.title
            : window.WPVUE.site_name + " " + this.routerTitle
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.og.title
            : window.WPVUE.site_name + " " + this.routerTitle
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.og.url
            : window.location.href
        },
        {
          mid: "og:site_name",
          property: "og:site_name",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.og.site_name
            : window.WPVUE.site_name
        },
        {
          mid: "twitter:title",
          name: "twitter:title",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.twitter.title
            : window.WPVUE.site_name + " " + this.routerTitle
        },
        {
          mid: "twitter:description",
          name: "twitter:description",
          content: this.getCurrentPageMeta
            ? this.getCurrentPageMeta.twitter.title
            : window.WPVUE.site_name + " " + this.routerTitle
        }
      ]
    };
  },
  beforeMount() {
    //alert('a');
  },
  mounted() {
    //this.removeNotUpdatingMeta();
    const VM = this;
    VM.routerTitle =
      this.$route && this.$route.meta && this.$route.meta.title
        ? this.$route.meta.title
        : VM.routerTitle;
    VM.setAppVersion(window.WPVUE.app_cache_version);
    VM.checkNavigationBehav();
    if (!this.pageIsInitialized && window.location.pathname === "/") {
      this.initLoading();
      this.pageIsInitialized = true;
    }
    setTimeout(() => {
      VM.fixTransfrom = true;
    }, 250);
  },
  destroyed() {
    //this.closeMenuViewMQ.removeEventListener();
  }
};
</script>

<style lang="scss">
@import "./assets/scss/style.scss";
</style>
